module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.details.Name.length > 0) ? _c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_vm._v("Features: ")]), _vm._v(" "), _c('div', {
    staticClass: "panel-body log"
  }, _vm._l((_vm.details.Name), function(cell) {
    return _c('div', [_c('span', [_vm._v(_vm._s(cell))])])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.details.Score.length > 0) ? _c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_vm._v("Variable importance: ")]), _vm._v(" "), _c('div', {
    staticClass: "panel-body log"
  }, [_c('div', [_c('span', [_vm._v(_vm._s(_vm.details.Score.join(", ")))])])])]) : _vm._e(), _vm._v(" "), (_vm.details.FeatureSet.length > 0) ? _c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_vm._v("Datasets: ")]), _vm._v(" "), _c('div', {
    staticClass: "panel-body log"
  }, [_c('div', [_c('span', [_vm._v(_vm._s(_vm.details.FeatureSet.join(", ")))])])])]) : _vm._e(), _vm._v(" "), (_vm.details.Model.length > 0) ? _c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_vm._v("ML Algorithms: ")]), _vm._v(" "), _c('div', {
    staticClass: "panel-body log"
  }, _vm._l((_vm.details.Model), function(model) {
    return _c('div', [_c('span', {
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          return _vm.modelInfo(model, $event)
        }
      }
    }, [_vm._v(_vm._s(model.replace("-", ".")))])])
  }), 0)]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c384daa6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/views/exploratory/components/edge/EventLogger.vue
// module id = 1229
// module chunks = 1